import React from 'react';

interface ConsultationCTAProps {
  onConsult?: () => void;
  onRestart?: () => void;
  onShare?: () => void;
}

export default function ConsultationCTA({
  onConsult,
  onRestart,
  onShare,
}: ConsultationCTAProps) {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: '나의 예복 성향 분석 결과',
          text: '반수제 예복이 가장 잘 맞는다는 분석 결과를 받았어요.',
          url: window.location.href,
        });
      } catch {
        /* 사용자 취소 */
      }
    } else if (onShare) {
      onShare();
    }
  };

  return (
    <section className="bg-navy px-5 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[480px] md:max-w-[700px]">
        <div className="mb-8 text-center">
          <h2 className="mb-2 font-serif text-[20px] font-semibold tracking-tight text-cream md:text-[24px]">
            아직 반수제와 수제 중 고민된다면?
          </h2>
          <p className="text-[13px] leading-relaxed text-cream/60 md:text-[14px]">
            예산, 체형, 촬영 일정에 맞춰
            <br />
            어떤 방식이 더 현실적인지 정리해드릴게요.
          </p>
        </div>

        <div className="mb-6 flex flex-col gap-2.5 md:flex-row md:justify-center">
          <button
            onClick={onConsult}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-softgold px-6 py-3.5 text-[14px] font-semibold text-navy transition-colors hover:bg-softgold-light md:w-auto"
          >
            <i className="ri-chat-3-line" />
            내 상황에 맞게 상담받기
          </button>
        </div>

        <div className="flex items-center justify-center gap-4">
          <button
            onClick={handleShare}
            className="flex items-center gap-1.5 text-[12px] text-cream/40 transition-colors hover:text-cream/70"
          >
            <i className="ri-share-forward-line" />
            결과 공유하기
          </button>
          <span className="text-cream/15">|</span>
          <button
            onClick={onRestart}
            className="flex items-center gap-1.5 text-[12px] text-cream/40 transition-colors hover:text-cream/70"
          >
            <i className="ri-restart-line" />
            다시 테스트하기
          </button>
        </div>
      </div>
    </section>
  );
}